module.exports = __webpack_public_path__ + "img/thomas-garrett.1cf62c38.png";